import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔹 Funcție reutilizabilă pentru verificarea sesiunii
  const checkSession = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.warn("⚠️ Fără token. Utilizator delogat.");
      setUser(null);
      setLoading(false);
      return;
    }

    try {
      const response = await fetch("https://casaverde.marenergy.ro/api/session.php", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await response.json();
        
      if (response.ok) {
        setUser(data.user);
        return data.user;
      } else {
        setUser(null);
        return null;
      }
    } catch (error) {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Verificare sesiune la reîncărcare pagină
  useEffect(() => {
    checkSession();
  }, []);

  // 🔹 Login (API Call)
  const login = async (email, password) => {
    try {
      const response = await fetch("https://casaverde.marenergy.ro/api/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("token", data.token);
        
        const user = await checkSession(); 

        return { ...data, user };
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      throw new Error("Conexiune eșuată. Încearcă din nou.");
    }
  };

  // 🔹 Logout (Ștergere Token)
  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, checkSession }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;